module.exports = __webpack_public_path__ + "img/motyl_2.757b5373.png";